// src/redux/mappers/loginMappers.ts
// Map backend response to frontend format
export const mapLoginResponse = (resp) => ({
  id: resp.id,
  name: resp.organizationName,
  value : resp.id,
  label : resp.organizationName
});